export default {
    getUser: state => state.user,
    getRoles: state => state.user ? state.user.roles : [],
}
